






import { defineComponent } from '@vue/composition-api'

// ================================
// Props
// ================================
export type MovieInfoHeadingProps = {
  originalTitle: string;
  releaseDate: string;
}

// ================================
// Component
// ================================
export default defineComponent({
  name: 'MovieInfoHeading',
  props: ['originalTitle', 'releaseDate'],
  setup (props: MovieInfoHeadingProps) {
    return {
      props
    }
  }
})
